import { render, staticRenderFns } from "./PanelAidedDesign.vue?vue&type=template&id=19cffe44&scoped=true&"
import script from "./PanelAidedDesign.vue?vue&type=script&lang=js&"
export * from "./PanelAidedDesign.vue?vue&type=script&lang=js&"
import style0 from "./PanelAidedDesign.vue?vue&type=style&index=0&id=19cffe44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cffe44",
  null
  
)

export default component.exports